import React, { Fragment } from 'react';
import { SnackBar, CloseButton } from './styles';

export default function HeaderSnackbar({ handleHeaderSnackbar, fromCoursePage }) {
  return (
    <SnackBar background="var(--brandColor)" color="#fff" fromCoursePage={fromCoursePage}>
      <Fragment>
        Funding Alert: Log2Base2 raised $150K pre-seed round.
        <a
          className="ml-1 underlinedLink text-white no-text-wrap"
          href="https://www.thehindu.com/news/national/tamil-nadu/chennai-headquartered-log2base2-raises-12-crore-in-pre-seed-funding-round/article65931898.ece"
          target="_blank"
          rel="noopener noreferrer"
        >
          Read More
        </a>
      </Fragment>
      <CloseButton color="#fff" onClick={handleHeaderSnackbar} />
    </SnackBar>
  );
}
